// extracted by mini-css-extract-plugin
export default {"user":"User_user__q1KrV","notif":"User_notif__0ZKeU","new":"User_new__ze1Xd","logout":"User_logout__h5VGj"};